import { Slider as SourceSlider } from 'SourceComponent/Slider/Slider.component';
import media, { WYSIWYG_MEDIA } from "Util/Media/Media";
import { lazy } from "react";
import CSS from 'Util/CSS';

export const UniversalIcon = lazy(() => import(
    /* webpackMode: "lazy", webpackChunkName: "icons" */
    'Component/UniversalIcon'
    ));

export class Slider extends SourceSlider {

    setTranlateXStyle(translate) {
        const { isVertical, showCrumbs } = this.props;

        CSS.setVariable(
            this.draggableRef,
            isVertical ? 'translateY' : 'translateX',
            `${ translate }px`
            // `${ !showCrumbs ? translate : 0 }px`
        );
    }
    
    renderArrows() {
        const { showArrows, activeImage, children, device, mix } = {} = this.props;
        const nextIsDisabled = activeImage + 1 === children.length;
        const prevIsDisabled = activeImage === 0;

        let arrowNext = 'slider_arrow_next_dark.png';
        let arrowPrev = 'slider_arrow_next_dark.png';

        if(mix.mix && mix.mix.block && mix.mix.block.includes("Light")){
            arrowNext = 'slider_arrow_next_light.png';
            arrowPrev = 'slider_arrow_next_light.png';
        }

        if (!showArrows) {
            return null;
        }

        if (device.isMobile) {
            return (
                <div className="Slider-Arrows ContentWrapper">
                    <button
                        block="Slider"
                        elem="Arrow"
                        mods={ { isPrev: true, isDisabled: prevIsDisabled } }
                        aria-label={ __('Previous') }
                        onClick={ this.goPrev }
                    >
                        <UniversalIcon
                            src={media(arrowNext, WYSIWYG_MEDIA)}
                            alt="ChevronIcon"
                            className="ChevronIcon ChevronIcon_direction_left"
                        />
                    </button>
                    <button
                        block="Slider"
                        elem="Arrow"
                        mods={ { isNext: true, isDisabled: nextIsDisabled } }
                        aria-label={ __('Next') }
                        onClick={ this.goNext }
                    >
                        <UniversalIcon
                            src={media(arrowPrev, WYSIWYG_MEDIA)}
                            alt="ChevronIcon"
                            className="ChevronIcon ChevronIcon_direction_right"
                        />
                    </button>
                </div>
            );
        }

        return (
            <div className="Slider-Arrows ContentWrapper">
                <button
                    block="Slider"
                    elem="Arrow"
                    mods={ { isPrev: true, isDisabled: prevIsDisabled } }
                    aria-label={ __('Previous') }
                    onClick={ this.goPrev }
                >
                    <UniversalIcon
                        src={media(arrowPrev, WYSIWYG_MEDIA)}
                        alt="ChevronIcon"
                        className="ChevronIcon ChevronIcon_direction_left"
                    />
                </button>
                <button
                    block="Slider"
                    elem="Arrow"
                    mods={ { isNext: true, isDisabled: nextIsDisabled } }
                    aria-label={ __('Next') }
                    onClick={ this.goNext }
                >
                    <UniversalIcon
                        src={media(arrowPrev, WYSIWYG_MEDIA)}
                        alt="ChevronIcon"
                        className="ChevronIcon ChevronIcon_direction_right"
                    />
                </button>
            </div>
        );
    }

    render() {
        const { mix } = this.props;
        const height = `${this.sliderRef?.current?.offsetHeight || 0}px`

        return (
                <div
                  style={ { '--slider-height': height } }
                  block="Slider"
                  mix={ mix }
                  ref={ this.getSliderRef() }
                >
                    { this.renderSliderContent() }
                    { this.renderCrumbs() }
                    { this.renderArrows() }
                </div>
        );
    }
}

export default Slider;
